const PostFilter = (function () {
    let currentSortValue = '';
    let currentAuthorValue = '';
    let resultContainer = '';
    let loadMoreCount = '';
    let currentPaginationPage = 1;
    let paginationType = '';
    let categoryName = '';
    let baseTagSlug = '';
    let filterTagsString = '';
    let postPerPage = '';
    let totalPosts = '';
    let excludedPosts = '';
    let selectedFiltersSet = new Set();
    let selectedTaxonomies = new Map();

    function sendFilterRequest() {
        
        const data = new FormData();
        data.append('action', 'filter_js');
        data.append('nonce', window.touchitData.nonce);
        data.append('page', currentPaginationPage);
        data.append('paginationType', paginationType);

        if (loadMoreCount) data.append('postsPerPage', loadMoreCount);
        if (currentSortValue) data.append('sortValue', currentSortValue);
        if (currentAuthorValue) data.append('authorValue', currentAuthorValue);
        if (categoryName) data.append('categoryName', categoryName);
        if (baseTagSlug) data.append('baseTagSlug', baseTagSlug);
        if (filterTagsString) data.append('tagName', filterTagsString);
        if (excludedPosts) data.append('excludedPosts', excludedPosts);
        
        const taxonomyData = Array.from(selectedTaxonomies.entries()).map(([tag, tax]) => `${tag}:${tax}`).join(',');
        if (taxonomyData) data.append('taxonomyData', taxonomyData);

        fetch(touchitData.ajax_url, {
            method: 'POST',
            body: data
        })
            .then(response => response.text())
            .then(data => {
                if (resultContainer) {
                    resultContainer.innerHTML = data;

                    bindLoadMoreAndPagination();

                    const headerElement = document.querySelector('.all-articles_header');
                    if (headerElement && paginationType !== 'load-more') {
                        headerElement.scrollIntoView({ 
                            behavior: 'smooth', 
                            block: 'start' 
                        });
                    }

                    // Dispatch event for other modules
                    document.dispatchEvent(new CustomEvent('touchit:postsLoaded'));
                }
            })
            .catch(error => console.error('Error:', error));
    }

    function updateQueryParam(key, value) {
        const url = new URL(window.location.href);
        url.searchParams.set(key, value);
        window.history.pushState({}, '', url);
    }

    function getQueryParam(key) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(key);
    }

    function bindLoadMoreAndPagination() {
        if (paginationType === 'load-more') {
            const loadMoreButton = document.querySelector('.articles-list__load-more');
            if (loadMoreButton) {
                loadMoreButton.addEventListener('click', function () {
                    loadMoreCount = this.getAttribute('data-load-more-count');
                    sendFilterRequest();
                });
            }
        } else {
            const paginationPage = document.querySelectorAll('.pagination-button');
            paginationPage.forEach(function (option) {
                option.addEventListener('click', function () {
                    currentPaginationPage = this.getAttribute('data-page');
                    updateQueryParam('page', currentPaginationPage);
                    sendFilterRequest();
                });
            });

            const currentPageParam = getQueryParam('page');
            if (currentPageParam && currentPageParam != currentPaginationPage) {
                currentPaginationPage = currentPageParam;
                sendFilterRequest();
            }

            paginationPage.forEach(function (btn) {
                if (btn.getAttribute('data-page') == currentPaginationPage) {
                    btn.classList.add('active');
                } else {
                    btn.classList.remove('active');
                }
            });
        }
    }

    return {
        init: function () {
            resultContainer = document.querySelector('.articles-list');
            if (!resultContainer) return;

            paginationType = resultContainer.getAttribute('data-pagination-type') || 'load-more';
            categoryName = resultContainer.getAttribute('data-category') || '';
            postPerPage = resultContainer.getAttribute('data-post-per-page') || '';
            totalPosts = resultContainer.getAttribute('data-total-posts') || '';
            baseTagSlug = resultContainer.getAttribute('data-tag') || '';
            excludedPosts = resultContainer.getAttribute('data-excluded-posts') || '';

            selectedFiltersSet = new Set();

            const urlSortValue = getQueryParam('sort');
            const urlAuthorValue = getQueryParam('author');
            
            if (urlSortValue) currentSortValue = urlSortValue;
            if (urlAuthorValue) currentAuthorValue = urlAuthorValue;

            const tagLinks = document.querySelectorAll('.topics-and-filters .topic-tag');
            tagLinks.forEach(tag => {
                const tagSlug = tag.getAttribute('data-slug');
                if (selectedFiltersSet.has(tagSlug)) {
                    tag.classList.add('active');
                } else {
                    tag.classList.remove('active');
                }
            });

            const topicsContainer = document.querySelector('.topics-and-filters');
            if (topicsContainer) {
                topicsContainer.addEventListener('click', function (e) {
                    const tag = e.target.closest('.topic-tag');
                    if (!tag) return;

                    e.preventDefault();

                    currentAuthorValue = '';

                    const tagSlug = tag.getAttribute('data-slug');
                    if (!tagSlug) return;

                    const taxonomy = tag.getAttribute('data-taxonomy');

                    if (selectedFiltersSet.has(tagSlug)) {
                        selectedFiltersSet.delete(tagSlug);
                        selectedTaxonomies.delete(tagSlug);
                        tag.classList.remove('active');
                    } else {
                        selectedFiltersSet.add(tagSlug);
                        selectedTaxonomies.set(tagSlug, taxonomy);
                        tag.classList.add('active');
                    }

                    filterTagsString = Array.from(selectedFiltersSet).join(',');
                    currentPaginationPage = 1;
                    sendFilterRequest();
                });
            }

            const sortOptions = document.querySelectorAll('.sort-option');
            sortOptions.forEach(function (option) {
                option.addEventListener('click', function () {
                    currentSortValue = this.getAttribute('data-sort-date');
                    currentPaginationPage = 1;

                    sortOptions.forEach(opt => opt.classList.remove('active'));
                    this.classList.add('active');

                    updateQueryParam('sort', currentSortValue);
                    sendFilterRequest();
                });
            });

            if (currentSortValue) {
                sortOptions.forEach(option => {
                    if (option.getAttribute('data-sort-date') === currentSortValue) {
                        option.classList.add('active');
                    }
                });
            }

            const authorOptions = document.querySelectorAll('.author-option');
            authorOptions.forEach(function (option) {
                option.addEventListener('click', function () {
                    currentAuthorValue = this.getAttribute('data-author-id');
                    currentPaginationPage = 1;

                    authorOptions.forEach(opt => opt.classList.remove('active'));
                    this.classList.add('active');

                    updateQueryParam('author', currentAuthorValue);
                    
                    selectedFiltersSet.clear();
                    selectedTaxonomies.clear();
                    filterTagsString = '';
                    document.querySelectorAll('.topic-tag.active').forEach(tag => tag.classList.remove('active'));

                    sendFilterRequest();
                });
            });

            
            if (currentAuthorValue) {
                authorOptions.forEach(option => {
                    if (option.getAttribute('data-author-id') === currentAuthorValue) {
                        option.classList.add('active');
                    }
                });
            }

            bindLoadMoreAndPagination();

            const filters = document.querySelectorAll(".filter-sort, .filter-author");

            filters.forEach((filter) => {
                const dropdown = filter.querySelector(".sort-options, .author-options");
                if (!dropdown) return;

                filter.addEventListener("click", (e) => {
                    e.stopPropagation();

                    filters.forEach((otherFilter) => {
                        const otherDropdown = otherFilter.querySelector(
                            ".sort-options, .author-options"
                        );
                        if (otherDropdown && otherDropdown !== dropdown) {
                            otherDropdown.style.display = "none";
                        }
                    });

                    dropdown.style.display =
                        dropdown.style.display === "block" ? "none" : "block";
                });

                dropdown.addEventListener("click", (e) => {
                    e.stopPropagation();
                });
            });

            document.addEventListener("click", () => {
                document
                    .querySelectorAll(".sort-options, .author-options")
                    .forEach((dropdown) => {
                        dropdown.style.display = "none";
                    });
            });
        }
    };
})();

export default PostFilter;